import React from "react"
import PropTypes from "prop-types"
import { Modal as AntdModal } from "antd"
import styles from "./Modal.module.css"

export const Modal = ({ open, onCancel, children, footer = null, width = 1022, style, scrollable = false, ...rest }) => {
  return (
    <AntdModal
      className={styles.modal}
      open={open}
      onCancel={onCancel}
      footer={footer}
      width={width}
      style={style}
      classNames={scrollable ? { body: styles.scrollableBody } : undefined}
      {...rest}
    >
      {children}
    </AntdModal>
  )
}

Modal.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  children: PropTypes.node,
  footer: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,
  scrollable: PropTypes.bool
}
